import { Prisma } from "@prisma/client";

export type ConsentParams = {
  organiserId?: string;
  structureId?: string;
  userId?: string;
};

export const selectedConsentValues = {
  id: true,
  hasConsented: true,
  userId: true,
  user: {
    select: {
      email: true,
      firstName: true,
      lastName: true,
      roles: true,
      visitors: true,
      isProfessional: true,
    },
  },
  organiserId: true,
  organiser: {
    select: {
      admin: {
        select: {
          businessName: true,
          firstName: true,
          lastName: true,
          email: true,
        },
      },
    },
  },
  structureId: true,
  structure: {
    select: {
      businessName: true,
      admin: {
        select: {
          businessName: true,
          firstName: true,
          lastName: true,
          email: true,
        },
      },
    },
  },
  createdAt: true,
} satisfies Prisma.ConsentSelect | Prisma.ConsentHistorySelect;

export const consentValues = Prisma.validator<Prisma.ConsentDefaultArgs>()({
  select: selectedConsentValues,
});
export type ConsentPrisma = Prisma.ConsentGetPayload<typeof consentValues>;

export const consentHistoryValues =
  Prisma.validator<Prisma.ConsentHistoryDefaultArgs>()({
    select: selectedConsentValues,
  });
export type ConsentHistoryPrisma = Prisma.ConsentHistoryGetPayload<
  typeof consentHistoryValues
>;
